// extracted by mini-css-extract-plugin
export default {"header":"Header_header__tMziA","container":"Header_container__QBsmS","wrapper":"Header_wrapper__fklTD","support":"Header_support__LDuhN","scrolled":"Header_scrolled__9AGr4"};